
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminal/how-to-setup",
      function () {
        return require("private-next-pages/terminal/how-to-setup/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminal/how-to-setup"])
      });
    }
  